//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";

export default {
  name: "FOUR",
  data() {
    return {
      defaultJson: {
        Brainstem2: "无瞳孔或角膜反射",
        Eye1: "闭眼但刺痛睁眼",
        "Eye3 (short)": "无跟随运动",
        Motor4: "竖起拇指或握拳等",
        Brainstem: "脑干",
        "Brainstem2 (short)": "无瞳孔或角膜反射",
        "Respiration1 (short)": "触发呼吸机",
        Brainstem0: "无反射（瞳孔、角膜及咳嗽）",
        "Motor1 (short)": "伸展反应",
        Motor3: "对疼痛可定位",
        Respiration2: "异常呼吸模式",
        "Respiration4 (short)": "正常呼吸",
        "Resp.": "呼吸",
        Motor2: "疼痛后屈曲反应",
        Eye2: "闭眼但大声呼唤后睁眼",
        "Eye4 (short)": "听从指令",
        "Motor2 (short)": "屈曲反应",
        Motor1: "伸展反应",
        "Brainstem3 (short)": "单侧瞳孔散大且固定",
        MotorTitle: "运动反应",
        "Respiration0 (short)": "呼吸暂停或机械控制",
        Motor0: "对疼痛无反应或全身肌阵挛状态",
        "Brainstem0 (short)": "无反射",
        Brainstem3: "单侧瞳孔散大且固定",
        "Eye0 (short)": "无睁眼",
        Respiration1: "触发呼吸机或以高于呼吸机的频率呼吸",
        Eye3: "睁眼但无跟随运动",
        "E {{ eye }}  M {{ mot }}  B {{ brain }}  R {{ resp }}":
          "眼睛 {{ eye }}  运动 {{ mot }}  大脑 {{ brain }}  反应 {{ resp }}",
        Respiration4: "正常呼吸模式",
        Brainstem1: "无瞳孔及角膜反射",
        BrainstemTitle: "脑干反射",
        "Motor3 (short)": "定位疼痛",
        "Respiration3 (short)": "潮式呼吸",
        "Brainstem4 (short)": "瞳孔及角膜反射（+）",
        RespirationTitle: "呼吸",
        "Eye1 (short)": "刺痛睁眼",
        Eye4: "睁眼，有跟随运动或听从指令眨眼",
        EyeTitle: "眼睛反应",
        "Motor4 (short)": "有意义",
        Eye0: "疼痛刺激无睁眼",
        Respiration0: "呼吸暂停或完全依赖机械通气",
        Eyes: "眼睛",
        "Brainstem1 (short)": "无瞳孔及角膜反射",
        "Eye2 (short)": "大声呼唤后睁眼",
        "Motor0 (short)": "无反应",
        Brainstem4: "双侧瞳孔及角膜反射存在",
        Motor: "运动",
        "Respiration2 (short)": "异常呼吸",
        Respiration3: "潮式呼吸模式",
      },
      form: {
        eye: "",
        mot: "",
        brain: "",
        resp: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "疼痛刺激无睁眼", shortName: "无睁眼" },
        { value: "1", name: "闭眼但刺痛睁眼", shortName: "刺痛睁眼" },
        {
          value: "2",
          name: "闭眼但大声呼唤后睁眼",
          shortName: "大声呼唤后睁眼",
        },
        { value: "3", name: "睁眼但无跟随运动", shortName: "无跟随运动" },
        {
          value: "4",
          name: "睁眼，有跟随运动或听从指令眨眼",
          shortName: "听从指令",
        },
      ],
      dataList2: [
        {
          value: "0",
          name: "对疼痛无反应或全身肌阵挛状态",
          shortName: "无反应",
        },
        { value: "1", name: "伸展反应", shortName: "伸展反应" },
        { value: "2", name: "疼痛后屈曲反应", shortName: "屈曲反应" },
        { value: "3", name: "对疼痛可定位", shortName: "定位疼痛" },
        { value: "4", name: "竖起拇指或握拳等", shortName: "有意义" },
      ],
      dataList3: [
        { value: "0", name: "无反射（瞳孔、角膜及咳嗽）", shortName: "无反射" },
        { value: "1", name: "无瞳孔及角膜反射", shortName: "无瞳孔及角膜反射" },
        { value: "2", name: "无瞳孔或角膜反射", shortName: "无瞳孔或角膜反射" },
        {
          value: "3",
          name: "单侧瞳孔散大且固定",
          shortName: "单侧瞳孔散大且固定",
        },
        {
          value: "4",
          name: "双侧瞳孔及角膜反射存在",
          shortName: "瞳孔及角膜反射（+）",
        },
      ],
      dataList4: [
        {
          value: "0",
          name: "呼吸暂停或完全依赖机械通气",
          shortName: "呼吸暂停或机械控制",
        },
        {
          value: "1",
          name: "触发呼吸机或以高于呼吸机的频率呼吸",
          shortName: "触发呼吸机",
        },
        { value: "2", name: "异常呼吸模式", shortName: "异常呼吸" },
        { value: "3", name: "潮式呼吸模式", shortName: "潮式呼吸" },
        { value: "4", name: "正常呼吸模式", shortName: "正常呼吸" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),

    maxNSum(num, obj) {
      let self = this;
    },
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // eye + mot + brain + resp
        let result = form.eye + form.mot + form.brain + form.resp;
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/FOUR.vue